import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersInfoV2Service {
  private readonly url = `${environment.api_v2}/v2/user-info`;

  constructor(private readonly http: HttpClient) {}

  getAvailableInfo() {
    return this.http.get<boolean>(`${this.url}/available`).pipe(take(1));
  }
}
